import { FlightGenerationParams } from './../objects/flightGenerationParams';
import { getDefaultCurrency } from '../../../functions/getDefaultCurrency';
// Types
import { Column } from '../objects/column';
import { Segment, SegmentPeriod } from '../objects/segment';
import { ManualFlight } from '../objects/manualFlight';
import { Preferences } from '../../profile/objects/preferences';
import { ManualFlightState } from '../objects/manualFlightState';
import {
    ADD_PREFERENCES,
    ADD_SEGMENT,
    PATHING_ADD_SEGMENT,
    PATHING_DELETE_SEGMENT,
    DELETE_SEGMENT,
    ManualFlightActionTypes,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_FILTERS,
    RESET_MANUAL_FLIGHT,
    SET_DELETE,
    SET_DUPLICATE,
    SET_CREATE_SUCCESSIF,
    SET_CREATE_STEP,
    SET_ERRORS,
    SET_SEGMENTS_OUTBOUND_FIRST_DATE,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_MANUAL_FLIGHT,
    SET_MANUAL_FLIGHT_ACTIVATE,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_MANUAL_FLIGHT_PREFERENCES,
    SET_RUNNING,
    SET_SCROLL_ID,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_REFRESH_EDIT_FLIGHT_SERIES,
    TOGGLE_EDIT_DOMESTIC_SEGMENTS,
    TOGGLE_EDIT_FLIGHT_INFO,
    TOGGLE_EDIT_OUTBOUND_SEGMENTS,
    TOGGLE_PATHING_EDIT_OUTBOUND_SEGMENTS,
    TOGGLE_EDIT_RETURN_SEGMENTS,
    TOGGLE_PATHING_EDIT_RETURN_SEGMENTS,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_AIRLINE,
    UPDATE_CURRENCY,
    UPDATE_FILTER_ACTIVE,
    UPDATE_FILTER_AIRLINE,
    UPDATE_FILTER_AIRPORT,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_END_DATE_GTE,
    UPDATE_FILTER_END_DATE_LTE,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_PNR_NUMBER,
    UPDATE_FILTER_START_DATE_GTE,
    UPDATE_FILTER_START_DATE_LTE,
    UPDATE_PNR_NUMBER,
    UPDATE_PRICE_ADULT,
    UPDATE_PRICE_CHILD,
    UPDATE_PRICE_INFANT,
    UPDATE_PURCHASE_PRICE_ADULT,
    UPDATE_PURCHASE_PRICE_CHILD,
    UPDATE_PURCHASE_PRICE_INFANT,
    UPDATE_PATHING_SEGMENT_PROPERTY,
    UPDATE_SEGMENT_AIRCRAFT,
    UPDATE_SEGMENT_AIRLINE,
    UPDATE_SEGMENT_BAG_UNIT,
    UPDATE_SEGMENT_CABIN_CLASS,
    UPDATE_SEGMENT_CABIN_CLASS_CODE,
    UPDATE_SEGMENT_CARRY_BAG_NUMBER,
    UPDATE_SEGMENT_CARRY_BAG_WEIGHT,
    UPDATE_SEGMENT_CHECKED_BAG_NUMBER,
    UPDATE_SEGMENT_CHECKED_BAG_WEIGHT,
    UPDATE_SEGMENT_DESTINATION_AIRPORT,
    UPDATE_SEGMENT_DESTINATION_STATION,
    UPDATE_SEGMENT_DESTINATION_TERMINAL,
    UPDATE_SEGMENT_DURATION_HOUR,
    UPDATE_SEGMENT_DURATION_MINUTE,
    UPDATE_SEGMENT_END_DATE,
    UPDATE_SEGMENT_END_DATE_HOUR,
    UPDATE_SEGMENT_END_DATE_MINUTE,
    UPDATE_SEGMENT_FLIGHT_NUMBER,
    UPDATE_SEGMENT_IS_NIGHTLY,
    UPDATE_SEGMENT_MEAL_INCLUDED,
    UPDATE_SEGMENT_ORIGIN_AIRPORT,
    UPDATE_SEGMENT_ORIGIN_STATION,
    UPDATE_SEGMENT_ORIGIN_TERMINAL,
    UPDATE_SEGMENT_START_DATE,
    UPDATE_SEGMENT_START_DATE_HOUR,
    UPDATE_SEGMENT_START_DATE_MINUTE,
    UPDATE_TAXES_ADULT,
    UPDATE_TAXES_CHILD,
    UPDATE_TAXES_INFANT,
    UPDATE_TOTAL_STOCK,
    UPDATE_SEGMENT_PERIOD_FIELD,
    GENERATE_FLIGHT_SERIES,
    UPDATE_FLIGHT_SERIES,
    REGROUP_FLIGHT_SERIES,
    UPDATE_FLIGHTS_GENERATIONS_PARAMS,
    DELETE_FLIGHTS_GENERATIONS_PARAMS,
    ADD_FLIGHTS_GENERATIONS_PARAMS,
    UPDATE_RETROCESSION_DATE_NUMBER,
    UPDATE_RETROCESSION_DATE_DATE,
    UPDATE_RETROCESSION_DATE_TYPE,
    UPDATE_PATHING_FIELD,
    UPDATE_AIRLINE_PATHING,
    ADD_PRE_POST_PATHING,
    TOGGLE_PATHING_EDIT_FLIGHT_INFO,
    SET_FROM_SERIES,
    SET_EDIT_STEP,
    SET_IS_FLIGHT_SERIES_OPEN,
    SET_PATHING,
    SET_PATHINGS,
    SET_REFRESH_PATHINGS,
    SET_LOADING_PATHINGS,
    SET_COLUMNS,
    ADD_PATHING_FORM,
    DELETE_PATHING_FORM,
    UPDATE_PATHING_FORM,
    UPDATE_PATHING_FORMS_SEGMENT_PROPERTY,
    ADD_PATHING_FORMS_SEGMENT,
    DELETE_PATHING_FORMS_SEGMENT,
    UPDATE_AIRLINE_PATHING_FORMS,
    SET_DELETE_PATHING,
    UPDATE_CIRCUIT_LIST,
    UPDATE_TARGET,
    RESIZE_COLUMN,
    SET_SELECTED_MANUAL_FLIGHTS,
    SET_MANUAL_FLIGHT_BATCH_ACTIVATE,
    SET_MANUAL_FLIGHT_BATCH_DELETE
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { cloneDeep, isNumber } from 'lodash';
import { generateFlightSeries } from '../utils/genereateFlightSeries';
import { getSeriesMinDate } from '../utils/getSeriesMinDate';
import { regroupManualFlight } from '../utils/regroupManualFlight';
import { DEFAULT_COLUMN } from '../constants/manualFlighArrayConstants';
import { DEFAULT_CURRENCY, EMPTY_PATHING_FORM } from '../constants/manualFlightConstants';
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { setManualFlightPreference } from '../utils/setManualFlightPreference';

const EMPTY_FLIGHT_GENERATION_PARAMS: FlightGenerationParams = {
    days: [],
    is_daily: false,
    start_date: null,
    end_date: null,
    frequency: '',
    days_error: '',
    start_date_error: '',
    end_date_error: '',
    frequency_error: '',
    is_one_day: false,
};
const EMPTY_SEGMENT_PERIOD: SegmentPeriod = {
    date_gte: null,
    date_gte_error: '',
    date_lte: null,
    date_lte_error: '',
    hour_gte: 12,
    hour_lte: 12,
    minute_gte: 30,
    minute_lte: 30,
};
const segment: Segment = {
    origin_airport: null,
    origin_airport_error: '',
    destination_airport: null,
    destination_airport_error: '',
    origin_station: null,
    origin_station_error: '',
    destination_station: null,
    destination_station_error: '',
    airline: null,
    airline_error: '',
    aircraft: null,
    aircraft_error: '',
    origin_terminal: '',
    destination_terminal: '',
    duration_hour: 1,
    duration_minute: 30,
    duration_minute_error: '',
    start_date: '',
    end_date: '',
    date_gte: null,
    date_gte_error: '',
    date_lte: null,
    date_lte_error: '',
    periods: [{ ...EMPTY_SEGMENT_PERIOD }],
    hour_gte: 12,
    hour_lte: 12,
    minute_gte: 30,
    minute_lte: 30,
    stop_duration_hour: 30,
    stop_duration_minute: 30,
    flight_number: '',
    flight_number_error: '',
    cabin_class: 'economy',
    cabin_class_code: '',
    checked_bag_number: 0,
    checked_bag_number_error: '',
    checked_bag_weight: 0,
    checked_bag_weight_error: '',
    carry_bag_number: 0,
    carry_bag_number_error: '',
    carry_bag_weight: 0,
    carry_bag_weight_error: '',
    bag_unit: 'KG',
    group: 0,
    meal_included: false,
    is_nightly: false,
    min_date_gte: null,
    min_date_lte: null
};

const initialState: ManualFlightState = {
    refresh_edit_flight_series: false,
    pathing: null,
    delete_pathing: null,
    pathings: [],
    pathing_forms: [EMPTY_PATHING_FORM],
    refresh_pathings: false,
    loading_pathings: false,
    is_flight_series_open: false,
    edit_step: 'INFO',
    add_pre_post_pathing: false,
    retrocession_date_number: '',
    retrocession_date_date: null,
    retrocession_date_date_error: '',
    retrocession_date_type: 'NUMBER',
    circuit_list: [],
    target: 'ANY',
    retrocession_min_date: null,
    airline: null,
    airline_error: '',
    columns: DEFAULT_COLUMN,
    count: 0,
    from_series: false,
    create: false,
    duplicate: false,
    create_successif: false,
    segments_outbound_first_date: null,
    currency: getDefaultCurrency(),
    currency_error: '',
    delete_manual_flight: null,
    edit_flight_info: false,
    pathing_edit_flight_info: false,
    edit_domestic_segments: false,
    edit_outbound_segments: false,
    edit_return_segments: false,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_airline: null,
    filter_airport: null,
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_name: '',
    filter_end_date_gte: null,
    filter_end_date_lte: null,
    filter_is_active: 'BOTH',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    filter_pnr_number: '',
    filter_start_date_gte: null,
    filter_start_date_lte: null,
    limit: 50,
    list: null,
    manual_flight: null,
    manual_flight_activate: null,
    order: 'asc',
    order_by: '-created_date',
    page: 0,
    pnr_number: '',
    pnr_number_error: '',
    preferences: [],
    price_adult: 0,
    price_adult_error: '',
    price_child: 0,
    price_child_error: '',
    price_infant: 0,
    price_infant_error: '',
    purchase_price_adult: 0,
    purchase_price_adult_error: '',
    purchase_price_child: 0,
    purchase_price_child_error: '',
    purchase_price_infant: 0,
    purchase_price_infant_error: '',

    pathing_edit_return_segments: false,
    pathing_edit_outbound_segments: false,
    pathing_airline: null,
    pathing_airline_error: '',
    pathing_currency: getDefaultCurrency(),
    pathing_currency_error: '',
    pathing_total_stock: 0,
    pathing_total_stock_error: '',
    pathing_pnr_number: '',
    pathing_pnr_number_error: '',
    pathing_price_adult: 0,
    pathing_price_adult_error: '',
    pathing_price_child: 0,
    pathing_price_child_error: '',
    pathing_price_infant: 0,
    pathing_price_infant_error: '',
    pathing_purchase_price_adult: 0,
    pathing_purchase_price_adult_error: '',
    pathing_purchase_price_child: 0,
    pathing_purchase_price_child_error: '',
    pathing_purchase_price_infant: 0,
    pathing_purchase_price_infant_error: '',
    pathing_segments_outbound: [],
    pathing_segments_outbound_control: [],
    pathing_segments_return: [],
    pathing_segments_return_control: [],
    pathing_taxes_adult: 0,
    pathing_taxes_adult_error: '',
    pathing_taxes_child: 0,
    pathing_taxes_child_error: '',
    pathing_taxes_infant: 0,
    pathing_taxes_infant_error: '',
    pathing_segments_outbound_first_date: null,

    refresh: false,
    running: false,
    scroll_id: null,
    search: '',
    segments_domestic: [],
    segments_domestic_control: [],
    segments_outbound: [{ ...segment }],
    segments_outbound_control: [{ ...segment }],
    segments_return: [],
    segments_return_control: [],
    taxes_adult: 0,
    taxes_adult_error: '',
    taxes_child: 0,
    taxes_child_error: '',
    taxes_infant: 0,
    taxes_infant_error: '',
    total_stock: 0,
    total_stock_error: '',
    flights_generations_params: [{ ...EMPTY_FLIGHT_GENERATION_PARAMS }],
    create_step: 0,
    flight_series: [],
    selected_manual_flights: [],
    manual_flight_batch_activate: null,
    manual_flight_batch_delete: false,
};

const updateSegmentProperty = (value: any, origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN', domestic_index: number | undefined, segment_index: number, state: ManualFlightState, key: string) => {
    switch (origin) {
        case 'OUTBOUND':
        {
            const segments_outbound: Segment[] = [...state.segments_outbound];
            const segment_outbound: Segment = { ...segments_outbound[segment_index] };
            segment_outbound[key] = value;
            if(segment_outbound[`${key}_error`]){
                segment_outbound[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_outbound.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_index < segments_outbound.length - 1) {
                    const segment_outbound_next: Segment = { ...segments_outbound[segment_index + 1] };
                    segment_outbound_next.min_date_gte = value;
                    segments_outbound[segment_index + 1] = segment_outbound_next;
                }
            }
            segments_outbound[segment_index] = segment_outbound;
            return { ...state, segments_outbound: segments_outbound };
        }
        case 'DOMESTIC':
            if (domestic_index !== undefined) {
                const segments_domestic: Segment[][] = [...state.segments_domestic];
                const current_domestic: Segment[] = [...segments_domestic[domestic_index]];
                const segment_domestic: Segment = { ...current_domestic[segment_index] };
                segment_domestic[key] = value;
                if(segment_domestic[`${key}_error`]){
                    segment_domestic[`${key}_error`] = '';
                }
                if (key === 'date_gte') {
                    segment_domestic.min_date_lte = value;
                } else if (key === 'date_lte') {
                    if (current_domestic.length - 1 < segment_index) {
                        const segment_domestic_next: Segment = { ...current_domestic[segment_index + 1] };
                        segment_domestic_next.min_date_gte = value;
                        current_domestic[segment_index + 1] = segment_domestic;
                    }
                }
                current_domestic[segment_index] = segment_domestic;
                segments_domestic[domestic_index] = current_domestic;
                return { ...state, segments_domestic: segments_domestic };
            }
            return state;
        case 'RETURN':
        {
            const segments_return: Segment[] = [...state.segments_return];
            const segment_return: Segment = { ...segments_return[segment_index] };
            segment_return[key] = value;
            if(segment_return[`${key}_error`]){
                segment_return[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_return.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_return.length - 1 < segment_index) {
                    const segment_return_next: Segment = { ...segment_return[segment_index + 1] };
                    segment_return_next.min_date_gte = value;
                    segment_return[segment_index + 1] = segment_return_next;
                }
            }
            segments_return[segment_index] = segment_return;
            return { ...state, segments_return: segments_return };
        }
        default:
            return state;
    }
};


const updatePathingProperty = (value: any, origin: 'OUTBOUND' | 'RETURN', domestic_index: number | undefined, segment_index: number, state: ManualFlightState, key: keyof Segment) => {
    switch (origin) {
        case 'OUTBOUND':
        {
            const segments_outbound: Segment[] = [...state.pathing_segments_outbound];
            const segment_outbound: Segment = { ...segments_outbound[segment_index] };
            segment_outbound[key] = value;
            if(segment_outbound[`${key}_error`]){
                segment_outbound[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_outbound.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_index < segments_outbound.length - 1) {
                    const segment_outbound_next: Segment = { ...segments_outbound[segment_index + 1] };
                    segment_outbound_next.min_date_gte = value;
                    segments_outbound[segment_index + 1] = segment_outbound_next;
                }
            }
            segments_outbound[segment_index] = segment_outbound;
            return { ...state, pathing_segments_outbound: segments_outbound };
        }
        case 'RETURN':
        {
            const segments_return: Segment[] = [...state.pathing_segments_return];
            const segment_return: Segment = { ...segments_return[segment_index] };
            segment_return[key] = value;
            if(segment_return[`${key}_error`]){
                segment_return[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_return.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_return.length - 1 < segment_index) {
                    const segment_return_next: Segment = { ...segment_return[segment_index + 1] };
                    segment_return_next.min_date_gte = value;
                    segment_return[segment_index + 1] = segment_return_next;
                }
            }
            segments_return[segment_index] = segment_return;
            return { ...state, pathing_segments_return: segments_return };
        }
        default:
            return state;
    }
};

const updatePathingFormsSegmentProperty = (pathing_index: number, value: any, origin: 'OUTBOUND' | 'RETURN', segment_index: number, state: ManualFlightState, key: keyof Segment) => {
    const pathing = cloneDeep(state.pathing_forms[pathing_index]);
    switch (origin) {
        case 'OUTBOUND':
        {
            const segments_outbound: Segment[] = [...pathing.segments_outbound];
            const segment_outbound: Segment = { ...segments_outbound[segment_index] };
            segment_outbound[key] = value;
            if(segment_outbound[`${key}_error`]){
                segment_outbound[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_outbound.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_index < segments_outbound.length - 1) {
                    const segment_outbound_next: Segment = { ...segments_outbound[segment_index + 1] };
                    segment_outbound_next.min_date_gte = value;
                    segments_outbound[segment_index + 1] = segment_outbound_next;
                }
            }
            segments_outbound[segment_index] = segment_outbound;
            pathing.segments_outbound = segments_outbound;
            return { ...state, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? pathing: pathing_form) };
        }
        case 'RETURN':
        {
            const segments_return: Segment[] = [...pathing.segments_return];
            const segment_return: Segment = { ...segments_return[segment_index] };
            segment_return[key] = value;
            if(segment_return[`${key}_error`]){
                segment_return[`${key}_error`] = '';
            }
            if (key === 'date_gte') {
                segment_return.min_date_lte = value;
            } else if (key === 'date_lte') {
                if (segment_return.length - 1 < segment_index) {
                    const segment_return_next: Segment = { ...segment_return[segment_index + 1] };
                    segment_return_next.min_date_gte = value;
                    segment_return[segment_index + 1] = segment_return_next;
                }
            }
            segments_return[segment_index] = segment_return;
            pathing.segments_return = segments_return;
            return { ...state, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? pathing: pathing_form) };
        }
        default:
            return state;
    }
};

const getSegments = (manual_flight: ManualFlight) => {
    const segments_outbound: Segment[] = [];
    const segments_domestic: Segment[][] = [];
    const segments_return: Segment[] = [];
    manual_flight.segments.map(segment => {
        const start_date = new Date(segment.start_date);
        const end_date = new Date(segment.end_date);
        segment.date_gte = new Date(segment.start_date.replace('Z', ''));
        segment.date_lte = new Date(segment.end_date.replace('Z', ''));
        segment.hour_gte = start_date.getUTCHours();
        segment.hour_lte = end_date.getUTCHours();
        segment.minute_gte = start_date.getUTCMinutes();
        segment.minute_lte = end_date.getUTCMinutes();
        segment.duration_hour = (segment.duration_minutes - (segment.duration_minutes % 60)) / 60;
        segment.duration_minute = segment.duration_minutes % 60;
        segment.origin_airport_error = '';
        segment.origin_station_error = '';
        segment.destination_airport_error = '';
        segment.destination_station_error = '';
        segment.airline_error = '';
        segment.aircraft_error = '';
        segment.date_gte_error = '';
        segment.date_lte_error = '';
        segment.duration_minute_error = '';
        segment.flight_number_error = '';
        segment.carry_bag_number_error = '';
        segment.carry_bag_weight_error = '';
        segment.checked_bag_number_error = '';
        segment.checked_bag_weight_error = '';
        if (segment.group === 0) {
            segments_outbound.push({ ...segment });
        } else if (segment.group !== 0 && segment.group !== manual_flight.segments[manual_flight.segments.length - 1].group) {
            if (segments_domestic.length === 0) {
                segments_domestic.push([{ ...segment }]);
            } else {
                if (segments_domestic[segments_domestic.length - 1][0].group === segment.group) {
                    segments_domestic[segments_domestic.length - 1].push({ ...segment });
                } else {
                    segments_domestic.push([{ ...segment }]);
                }
            }
        } else {
            segments_return.push({ ...segment });
        }
    });
    return { segments_outbound, segments_domestic, segments_return };
};

export default (state: ManualFlightState = initialState, action: ManualFlightActionTypes | ProfileActionTypes): ManualFlightState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return { ...state };
        }
        case ADD_SEGMENT: {
            const { type, index } = action.payload;
            switch (type) {
                case 'OUTBOUND':
                {
                    const segments_outbound: Segment[] = [...state.segments_outbound];
                    segments_outbound.push({ ...segment });
                    if (state.airline !== null) {
                        segments_outbound[segments_outbound.length - 1].airline = state.airline;
                    }
                    if (segments_outbound[segments_outbound.length - 2].date_lte !== null) {
                        segments_outbound[segments_outbound.length - 1].min_date_gte = segments_outbound[segments_outbound.length - 2].date_lte;
                    }
                    return { ...state, scroll_id: `manual-flight-outbound-segment-${segments_outbound.length - 1}`, segments_outbound: segments_outbound };
                }
                case 'DOMESTIC':
                {
                    if (index !== undefined) {
                        const segments_domestic: Segment[][] = [...state.segments_domestic];
                        const current_domestic: Segment[] = [...segments_domestic[index]];
                        current_domestic.push({ ...segment });
                        if (state.airline !== null) {
                            current_domestic[current_domestic.length - 1].airline = state.airline;
                        }
                        if (current_domestic[current_domestic.length - 2].date_lte !== null) {
                            current_domestic[current_domestic.length - 1].min_date_gte = current_domestic[current_domestic.length - 2].date_lte;
                        }
                        segments_domestic[index] = current_domestic;
                        return { ...state, scroll_id: `manual-flight-domestic-${index}-segment-${segments_domestic[index].length - 1}`, segments_domestic: segments_domestic };
                    } else {
                        const segments_domestic: Segment[][] = [...state.segments_domestic];
                        segments_domestic.push([{ ...segment }]);
                        if (state.airline !== null) {
                            segments_domestic[segments_domestic.length - 1][segments_domestic[segments_domestic.length - 1].length - 1].airline = state.airline;
                        }
                        if (segments_domestic.length > 1) {
                            if (segments_domestic[segments_domestic.length - 2][segments_domestic[segments_domestic.length - 2].length - 1].date_lte !== null) {
                                segments_domestic[segments_domestic.length - 1][segments_domestic[segments_domestic.length - 1].length - 1].min_date_gte = segments_domestic[segments_domestic.length - 2][segments_domestic[segments_domestic.length - 2].length - 1].date_lte;
                            }
                        } else if (state.segments_outbound.length > 0) {
                            if (state.segments_outbound[state.segments_outbound.length - 1].date_lte !== null) {
                                segments_domestic[segments_domestic.length - 1][segments_domestic[segments_domestic.length - 1].length - 1].min_date_gte = state.segments_outbound[state.segments_outbound.length - 1].date_lte;
                            }
                        }
                        return { ...state, scroll_id: `manual-flight-domestic-${segments_domestic.length - 1}-segment-${segments_domestic[segments_domestic.length - 1].length - 1}`, segments_domestic: segments_domestic };
                    }
                }
                case 'RETURN':
                {
                    const segments_return: Segment[] = [...state.segments_return];
                    const new_segment = { ...segment };
                    if (segments_return.length === 0) {
                        const last_outbound_segment = { ...state.segments_outbound[state.segments_outbound.length - 1] };
                        new_segment.origin_airport = last_outbound_segment.destination_airport;
                        new_segment.destination_airport = last_outbound_segment.origin_airport;
                        new_segment.origin_station = last_outbound_segment.destination_station;
                        new_segment.destination_station = last_outbound_segment.origin_station;
                        new_segment.airline = last_outbound_segment.airline;
                        new_segment.aircraft = last_outbound_segment.aircraft;
                        new_segment.origin_terminal = last_outbound_segment.destination_terminal;
                        new_segment.destination_terminal = last_outbound_segment.origin_terminal;
                        new_segment.cabin_class = last_outbound_segment.cabin_class;
                        new_segment.cabin_class_code = last_outbound_segment.cabin_class_code;
                        new_segment.checked_bag_number = last_outbound_segment.checked_bag_number === null ? '' : last_outbound_segment.checked_bag_number;
                        new_segment.checked_bag_weight = last_outbound_segment.checked_bag_weight === null ? '' : last_outbound_segment.checked_bag_weight;
                        new_segment.carry_bag_number = last_outbound_segment.carry_bag_number === null ? '' : last_outbound_segment.carry_bag_number;
                        new_segment.carry_bag_weight = last_outbound_segment.carry_bag_weight === null ? '' : last_outbound_segment.carry_bag_weight;
                        new_segment.bag_unit = last_outbound_segment.bag_unit;
                        new_segment.meal_included = last_outbound_segment.meal_included;
                    }
                    segments_return.push({ ...new_segment });
                    if (state.airline !== null) {
                        segments_return[segments_return.length - 1].airline = state.airline;
                    }
                    if (segments_return.length > 1) {
                        if (segments_return[segments_return.length - 2].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = segments_return[segments_return.length - 2].date_lte;
                        }
                    } else if (state.segments_domestic.length > 0) {
                        if (state.segments_domestic[state.segments_domestic.length - 1][state.segments_domestic[state.segments_domestic.length - 1].length - 1].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = state.segments_domestic[state.segments_domestic.length - 1][state.segments_domestic[state.segments_domestic.length - 1].length - 1].date_lte;
                        }
                    } else if (state.segments_outbound.length > 0) {
                        if (state.segments_outbound[state.segments_outbound.length - 1].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = state.segments_outbound[state.segments_outbound.length - 1].date_lte;
                        }
                    }
                    return { ...state, scroll_id: `manual-flight-return-segment-${segments_return.length - 1}`, segments_return: segments_return };
                }
                default:
                    return state;
            }
        }
        case ADD_PATHING_FORMS_SEGMENT: {
            const { type, pathing_index } = action.payload;
            const pathing = cloneDeep(state.pathing_forms[pathing_index]);
            switch (type) {
                case 'OUTBOUND':
                {
                    const segments_outbound: Segment[] = [...pathing.segments_outbound];
                    if(segments_outbound.length === 0) {
                        segments_outbound.push({ ...segment, date_gte: state.segments_outbound[0].date_gte, min_date_gte: state.segments_outbound[0].date_gte, min_date_lte: state.segments_outbound[0].date_gte });
                    } else {
                        segments_outbound.push({ ...segment });
                    }
                    if (pathing.airline !== null) {
                        segments_outbound[segments_outbound.length - 1].airline = pathing.airline;
                    }
                    if (segments_outbound.length>1 && segments_outbound[segments_outbound.length - 2].date_lte !== null) {
                        segments_outbound[segments_outbound.length - 1].min_date_gte = segments_outbound[segments_outbound.length - 2].date_lte;
                    }
                    pathing.segments_outbound = segments_outbound;
                    return { ...state, scroll_id: `manual-flight-outbound-segment-${segments_outbound.length - 1}`, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? pathing: pathing_form) };
                }
                case 'RETURN':
                {
                    const segments_return: Segment[] = [...pathing.segments_return];
                    const new_segment = { ...segment };
                    if (segments_return.length === 0) {
                        const last_outbound_segment = { ...state.segments_outbound[state.segments_outbound.length - 1] };
                        new_segment.origin_airport = last_outbound_segment.destination_airport;
                        new_segment.destination_airport = last_outbound_segment.origin_airport;
                        new_segment.origin_station = last_outbound_segment.destination_station;
                        new_segment.destination_station = last_outbound_segment.origin_station;
                        new_segment.airline = last_outbound_segment.airline;
                        new_segment.aircraft = last_outbound_segment.aircraft;
                        new_segment.origin_terminal = last_outbound_segment.destination_terminal;
                        new_segment.destination_terminal = last_outbound_segment.origin_terminal;
                        new_segment.cabin_class = last_outbound_segment.cabin_class;
                        new_segment.cabin_class_code = last_outbound_segment.cabin_class_code;
                        new_segment.checked_bag_number = last_outbound_segment.checked_bag_number === null ? '' : last_outbound_segment.checked_bag_number;
                        new_segment.checked_bag_weight = last_outbound_segment.checked_bag_weight === null ? '' : last_outbound_segment.checked_bag_weight;
                        new_segment.carry_bag_number = last_outbound_segment.carry_bag_number === null ? '' : last_outbound_segment.carry_bag_number;
                        new_segment.carry_bag_weight = last_outbound_segment.carry_bag_weight === null ? '' : last_outbound_segment.carry_bag_weight;
                        new_segment.bag_unit = last_outbound_segment.bag_unit;
                        new_segment.meal_included = last_outbound_segment.meal_included;
                    }
                    segments_return.push({ ...new_segment });
                    if (state.airline !== null) {
                        segments_return[segments_return.length - 1].airline = state.airline;
                    }
                    if (segments_return.length > 1) {
                        if (segments_return[segments_return.length - 2].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = segments_return[segments_return.length - 2].date_lte;
                        }
                    } else if (state.segments_domestic.length > 0) {
                        if (state.segments_domestic[state.segments_domestic.length - 1][state.segments_domestic[state.segments_domestic.length - 1].length - 1].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = state.segments_domestic[state.segments_domestic.length - 1][state.segments_domestic[state.segments_domestic.length - 1].length - 1].date_lte;
                        }
                    } else if (state.segments_outbound.length > 0) {
                        if (state.segments_outbound[state.segments_outbound.length - 1].date_lte !== null) {
                            segments_return[segments_return.length - 1].min_date_gte = state.segments_outbound[state.segments_outbound.length - 1].date_lte;
                        }
                    }
                    pathing.segments_return = segments_return;
                    return { ...state, scroll_id: `manual-flight-return-segment-${segments_return.length - 1}`, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? pathing: pathing_form) };
                }
                default:
                    return state;
            }
        }
        case PATHING_ADD_SEGMENT: {
            const { type, index } = action.payload;
            switch (type) {
                case 'OUTBOUND':
                {
                    const pathing_segments_outbound: Segment[] = [...state.pathing_segments_outbound];
                    pathing_segments_outbound.push({ ...segment });
                    if (state.pathing_airline !== null) {
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].airline = state.pathing_airline;
                    }
                    if (pathing_segments_outbound.length > 1 && pathing_segments_outbound[pathing_segments_outbound.length - 2].date_lte) {
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].min_date_gte = pathing_segments_outbound[pathing_segments_outbound.length - 2].date_lte;
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].min_date_lte = pathing_segments_outbound[pathing_segments_outbound.length - 2].date_lte;
                    } else {
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].date_gte = state.segments_outbound[0].date_gte;
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].min_date_gte = state.segments_outbound[0].date_gte;
                        pathing_segments_outbound[pathing_segments_outbound.length - 1].min_date_lte = state.segments_outbound[0].date_gte;
                    }
                    return { ...state, scroll_id: `manual-flight-outbound-segment-${pathing_segments_outbound.length - 1}`, pathing_segments_outbound: pathing_segments_outbound };
                }
                case 'RETURN':
                {
                    const pathing_segments_return: Segment[] = [...state.pathing_segments_return];
                    const new_segment = { ...segment };
                    if (pathing_segments_return.length === 0) {
                        const last_outbound_segment = state.pathing_segments_outbound.length >0 ? { ...state.pathing_segments_outbound[state.pathing_segments_outbound.length - 1] }: { ...segment };
                        new_segment.origin_airport = last_outbound_segment.destination_airport;
                        new_segment.destination_airport = last_outbound_segment.origin_airport;
                        new_segment.origin_station = last_outbound_segment.destination_station;
                        new_segment.destination_station = last_outbound_segment.origin_station;
                        new_segment.airline = last_outbound_segment.airline;
                        new_segment.aircraft = last_outbound_segment.aircraft;
                        new_segment.origin_terminal = last_outbound_segment.destination_terminal;
                        new_segment.destination_terminal = last_outbound_segment.origin_terminal;
                        new_segment.cabin_class = last_outbound_segment.cabin_class;
                        new_segment.cabin_class_code = last_outbound_segment.cabin_class_code;
                        new_segment.checked_bag_number = last_outbound_segment.checked_bag_number;
                        new_segment.checked_bag_weight = last_outbound_segment.checked_bag_weight;
                        new_segment.carry_bag_number = last_outbound_segment.carry_bag_number;
                        new_segment.carry_bag_weight = last_outbound_segment.carry_bag_weight;
                        new_segment.bag_unit = last_outbound_segment.bag_unit;
                        new_segment.meal_included = last_outbound_segment.meal_included;
                    }
                    pathing_segments_return.push({ ...new_segment });
                    if (state.pathing_airline !== null) {
                        pathing_segments_return[pathing_segments_return.length - 1].airline = state.pathing_airline;
                    }
                    if (pathing_segments_return.length > 1) {
                        if (pathing_segments_return[pathing_segments_return.length - 2].date_lte !== null) {
                            pathing_segments_return[pathing_segments_return.length - 1].min_date_gte = pathing_segments_return[pathing_segments_return.length - 2].date_lte;
                        }
                    } else if (state.pathing_segments_outbound.length > 0) {
                        if (state.pathing_segments_outbound[state.pathing_segments_outbound.length - 1].date_lte !== null) {
                            pathing_segments_return[pathing_segments_return.length - 1].min_date_gte = state.pathing_segments_outbound[state.pathing_segments_outbound.length - 1].date_lte;
                        }
                    }
                    return { ...state, scroll_id: `manual-flight-return-segment-${pathing_segments_return.length - 1}`, pathing_segments_return: pathing_segments_return };
                }
                default:
                    return state;
            }
        }
        case DELETE_SEGMENT: {
            const { type, index, domestic_index } = action.payload;
            switch (type) {
                case 'OUTBOUND':
                {
                    const segments_outbound: Segment[] = [...state.segments_outbound];
                    segments_outbound.splice(index, 1);
                    return { ...state, segments_outbound: segments_outbound };
                }
                case 'DOMESTIC':
                {
                    if (domestic_index !== undefined) {
                        const segments_domestic: Segment[][] = [...state.segments_domestic];
                        const current_domestic: Segment[] = [...segments_domestic[domestic_index]];
                        current_domestic.splice(index, 1);
                        if (current_domestic.length === 0) {
                            segments_domestic.splice(domestic_index, 1);
                        } else {
                            segments_domestic[domestic_index] = current_domestic;
                        }
                        return { ...state, segments_domestic: segments_domestic };
                    }
                    return state;
                }
                case 'RETURN':
                {
                    const segments_return: Segment[] = [...state.segments_return];
                    segments_return.splice(index, 1);
                    return { ...state, segments_return: segments_return };
                }
                default:
                    return state;
            }
        }
        case DELETE_PATHING_FORMS_SEGMENT: {
            const { type, index ,pathing_index } = action.payload;
            switch (type) {
                case 'OUTBOUND':
                {
                    return { ...state, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? { ...pathing_form, segments_outbound: pathing_form.segments_outbound.filter((_, segment_index) => segment_index !== index) }: pathing_form) };
                }
                case 'RETURN':
                {
                    return { ...state, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === pathing_index? { ...pathing_form, segments_return: pathing_form.segments_return.filter((_, segment_index) => segment_index !== index) }: pathing_form) };
                }
                default:
                    return state;
            }
        }
        case PATHING_DELETE_SEGMENT: {
            const { type, index, domestic_index } = action.payload;
            switch (type) {
                case 'OUTBOUND':
                {
                    const pathing_segments_outbound: Segment[] = [...state.pathing_segments_outbound];
                    pathing_segments_outbound.splice(index, 1);
                    return { ...state, pathing_segments_outbound: pathing_segments_outbound };
                }
                case 'RETURN':
                {
                    const pathing_segments_return: Segment[] = [...state.pathing_segments_return];
                    pathing_segments_return.splice(index, 1);
                    return { ...state, pathing_segments_return: pathing_segments_return };
                }
                default:
                    return state;
            }
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_airline: null,
                filter_airport: null,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_name: '',
                filter_end_date_gte: null,
                filter_end_date_lte: null,
                filter_is_active: 'BOTH',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0,
                filter_pnr_number: '',
                filter_start_date_gte: null,
                filter_start_date_lte: null
            };
        }
        case RESET_MANUAL_FLIGHT: {
            return {
                ...state,
                pathing: null,
                delete_pathing: null,
                pathings: [],
                pathing_forms: [EMPTY_PATHING_FORM],
                refresh_pathings: false,
                loading_pathings: false,
                retrocession_date_number: '',
                retrocession_date_date: null,
                retrocession_date_date_error: '',
                retrocession_date_type: 'NUMBER',
                circuit_list: [],
                target: 'ANY',
                retrocession_min_date: null,
                airline: null,
                airline_error: '',
                create: false,
                refresh_edit_flight_series: false,
                edit_step: 'INFO',
                is_flight_series_open: false,
                from_series: false,
                add_pre_post_pathing: false,
                segments_outbound_first_date: null,
                pathing_segments_outbound_first_date: null,
                duplicate: false,
                create_successif: false,
                edit_flight_info: false,
                pathing_edit_flight_info: false,
                edit_domestic_segments: false,
                edit_outbound_segments: false,
                pathing_edit_outbound_segments: false,
                edit_return_segments: false,
                pathing_edit_return_segments: false,
                currency: getDefaultCurrency(),
                currency_error: '',
                manual_flight: null,
                price_adult: 0,
                price_adult_error: '',
                price_child: 0,
                price_child_error: '',
                price_infant: 0,
                price_infant_error: '',
                purchase_price_adult: 0,
                purchase_price_adult_error: '',
                purchase_price_child: 0,
                purchase_price_child_error: '',
                purchase_price_infant: 0,
                purchase_price_infant_error: '',
                pnr_number: '',
                pnr_number_error: '',

                pathing_airline: null,
                pathing_airline_error: '',
                pathing_currency: getDefaultCurrency(),
                pathing_currency_error: '',
                pathing_total_stock: 0,
                pathing_total_stock_error: '',
                pathing_pnr_number: '',
                pathing_pnr_number_error: '',
                pathing_price_adult: 0,
                pathing_price_adult_error: '',
                pathing_price_child: 0,
                pathing_price_child_error: '',
                pathing_price_infant: 0,
                pathing_price_infant_error: '',
                pathing_purchase_price_adult: 0,
                pathing_purchase_price_adult_error: '',
                pathing_purchase_price_child: 0,
                pathing_purchase_price_child_error: '',
                pathing_purchase_price_infant: 0,
                pathing_purchase_price_infant_error: '',
                pathing_taxes_adult: 0,
                pathing_taxes_adult_error: '',
                pathing_taxes_child: 0,
                pathing_taxes_child_error: '',
                pathing_taxes_infant: 0,
                pathing_taxes_infant_error: '',
                pathing_segments_outbound: [],
                pathing_segments_outbound_control: [],
                pathing_segments_return: [],
                pathing_segments_return_control: [],

                segments_domestic: [],
                segments_domestic_control: [],
                segments_outbound: [{ ...segment }],
                segments_outbound_control: [{ ...segment }],
                segments_return: [],
                segments_return_control: [],
                taxes_adult: 0,
                taxes_adult_error: '',
                taxes_child: 0,
                taxes_child_error: '',
                taxes_infant: 0,
                taxes_infant_error: '',
                total_stock: 0,
                total_stock_error: '',
                flights_generations_params: [{ ...EMPTY_FLIGHT_GENERATION_PARAMS }],
                create_step: 0,
                flight_series: []
            };
        }
        case SET_DELETE: {
            if (action.payload === null && state.delete_manual_flight) {
                const list = state.list ? [...state.list] : state.list;
                let count = state.count;
                if (list) {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].id === state.delete_manual_flight.id) {
                            list.splice(i, 1);
                            count--;
                            break;
                        }
                    }
                }
                return { ...state, count: count, delete_manual_flight: action.payload, list: list };
            } else if (action.payload === false) {
                return { ...state, delete_manual_flight: null };
            } else {
                return { ...state, delete_manual_flight: action.payload };
            }
        }
        case SET_DELETE_PATHING: {
            return { ...state, delete_pathing: action.payload };
        }
        case SET_DUPLICATE: {
            const { segments_outbound, segments_domestic, segments_return } = getSegments(action.payload);
            return {
                ...state,
                duplicate: true,
                create: true,
                refresh_edit_flight_series: false,
                from_series: false,
                pathing_forms: [EMPTY_PATHING_FORM],
                retrocession_date_number: action.payload.retrocession_date_number ?? '',
                retrocession_date_date: action.payload.retrocession_date_date? new Date(action.payload.retrocession_date_date): null,
                retrocession_date_type: action.payload.retrocession_date_date? 'DATE': 'NUMBER',
                circuit_list: action.payload.circuit_list,
                target: action.payload.target,
                airline: action.payload.source,
                currency: action.payload.currency,
                pnr_number: action.payload.pnr_number,
                price_adult: action.payload.price_adult,
                purchase_price_adult: action.payload.purchase_price_adult,
                price_child: action.payload.price_child,
                purchase_price_child: action.payload.purchase_price_child,
                price_infant: action.payload.price_infant,
                purchase_price_infant: action.payload.purchase_price_infant,
                taxes_adult: action.payload.taxes_adult,
                taxes_child: action.payload.taxes_child,
                taxes_infant: action.payload.taxes_infant,
                total_stock: action.payload.total_stock,
                segments_outbound_first_date: segments_outbound[0].date_gte,
                segments_outbound: segments_outbound,
                segments_outbound_control: segments_outbound,
                segments_domestic: segments_domestic,
                segments_domestic_control: segments_domestic,
                segments_return: segments_return,
                segments_return_control: segments_return
            };
        }
        case SET_SEGMENTS_OUTBOUND_FIRST_DATE: {
            return { ... state, segments_outbound_first_date: action.payload };
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: ManualFlightState = cloneDeep(state);
            errors.map(error => {
                if(isNumber(error.pathing_index)){
                    if (error.segment_index !== undefined && error.segment_key !== undefined) {
                        const segments = [...new_state.pathing_forms[error.pathing_index][error.segment_key]];
                        const segment = { ...segments[error.segment_index] };
                        if (isNumber(error.period_index)){
                            const periods = [...segment.periods];
                            periods[error.period_index][error.key] = error.error;
                            segment['periods'] = periods;
                        } else {
                            segment[error.key] = error.error;
                        }
                        segments[error.segment_index] = segment;
                        new_state.pathing_forms[error.pathing_index][error.segment_key] = segments;
                    } else {
                        new_state.pathing_forms[error.pathing_index][error.key] = error.error;
                    }
                }
                else if(error.subKey){
                    const obj = [...new_state[error.key]];
                    const fligh_params = obj[error.period_index as number];
                    fligh_params[error.subKey] = error.error;
                    obj[error.period_index as number] = fligh_params;
                    new_state[error.key] = obj;
                }
                else if (error.segment_index !== undefined && error.segment_key !== undefined) {
                    const segments = [...new_state[error.segment_key]];
                    if (error.domestic_index !== undefined) {
                        const domestic = [...segments[error.domestic_index]];
                        const segment = { ...domestic[error.segment_index] };
                        if (isNumber(error.period_index)){
                            const periods = [...segment.periods];
                            periods[error.period_index][error.key] = error.error;
                            segment['periods'] = periods;
                        } else {
                            segment[error.key] = error.error;
                        }
                        domestic[error.segment_index] = segment;
                        segments[error.domestic_index] = domestic;
                        new_state[error.segment_key] = segments;
                    } else {
                        const segment = { ...segments[error.segment_index] };
                        if (isNumber(error.period_index)){
                            const periods = [...segment.periods];
                            periods[error.period_index][error.key] = error.error;
                            segment['periods'] = periods;
                        } else {
                            segment[error.key] = error.error;
                        }
                        segments[error.segment_index] = segment;
                        new_state[error.segment_key] = segments;
                    }
                } else {
                    new_state[error.key] = error.error;
                }
            });
            return { ...new_state };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_PREFERENCES: {
            const { columns, preferences, order_by, order } = setManualFlightPreference(action.payload, state.columns);
            return { ...state, columns, preferences, order_by, order };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        case SET_MANUAL_FLIGHT: {
            const { segments_outbound, segments_domestic, segments_return } = getSegments(action.payload);
            return {
                ...state,
                manual_flight: { ...action.payload, retrocession_date_date: action.payload.retrocession_date_date? new Date(action.payload.retrocession_date_date): null },
                retrocession_date_number: action.payload.retrocession_date_number ?? '',
                retrocession_date_date: action.payload.retrocession_date_date? new Date(action.payload.retrocession_date_date): null,
                retrocession_date_type: action.payload.retrocession_date_date? 'DATE': 'NUMBER',
                circuit_list: action.payload.circuit_list,
                target: action.payload.target,
                airline: action.payload.source,
                currency: action.payload.currency,
                pnr_number: action.payload.pnr_number,
                price_adult: action.payload.price_adult,
                purchase_price_adult: action.payload.purchase_price_adult,
                price_child: action.payload.price_child,
                purchase_price_child: action.payload.purchase_price_child,
                price_infant: action.payload.price_infant,
                purchase_price_infant: action.payload.purchase_price_infant,
                taxes_adult: action.payload.taxes_adult,
                taxes_child: action.payload.taxes_child,
                taxes_infant: action.payload.taxes_infant,
                total_stock: action.payload.total_stock,
                segments_outbound: segments_outbound,
                segments_outbound_control: segments_outbound,
                segments_domestic: segments_domestic,
                segments_domestic_control: segments_domestic,
                segments_return: segments_return,
                segments_return_control: segments_return,
                edit_flight_info: false,
                edit_outbound_segments: false,
                edit_domestic_segments: false,
                edit_return_segments: false,
            };
        }
        case SET_MANUAL_FLIGHT_ACTIVATE: {
            if (action.payload === false) {
                return { ...state, manual_flight_activate: null };
            } else if (action.payload !== null) {
                return { ...state, manual_flight_activate: action.payload };
            }
            return { ...state, refresh: !state.refresh, manual_flight_activate: null };
        }
        case SET_MANUAL_FLIGHT_PREFERENCES: {
            return { ...state, preferences: action.payload };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SCROLL_ID: {
            return { ...state, scroll_id: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, search: action.payload, page: 0 };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_CREATE: {
            return { ...state, create: !state.create };
        }
        case TOGGLE_REFRESH_EDIT_FLIGHT_SERIES: {
            return { ...state, refresh_edit_flight_series: !state.refresh_edit_flight_series };
        }
        case TOGGLE_EDIT_FLIGHT_INFO: {
            if (state.manual_flight !== null) {
                return {
                    ...state,
                    airline: state.manual_flight.source,
                    retrocession_date_number: state.manual_flight.retrocession_date_number ?? '',
                    retrocession_date_date: state.manual_flight.retrocession_date_date? new Date(state.manual_flight.retrocession_date_date): null,
                    retrocession_date_type: state.manual_flight.retrocession_date_date? 'DATE': 'NUMBER',
                    circuit_list: state.manual_flight.circuit_list,
                    target: state.manual_flight.target,
                    currency: state.manual_flight.currency,
                    pnr_number: state.manual_flight.pnr_number,
                    price_adult: state.manual_flight.price_adult,
                    purchase_price_adult: state.manual_flight.purchase_price_adult,
                    price_child: state.manual_flight.price_child,
                    purchase_price_child: state.manual_flight.purchase_price_child,
                    price_infant: state.manual_flight.price_infant,
                    purchase_price_infant: state.manual_flight.purchase_price_infant,
                    taxes_adult: state.manual_flight.taxes_adult,
                    taxes_child: state.manual_flight.taxes_child,
                    taxes_infant: state.manual_flight.taxes_infant,
                    total_stock: state.manual_flight.total_stock,
                    edit_flight_info: !state.edit_flight_info,
                };
            } else {
                return { ...state, edit_flight_info: !state.edit_flight_info };
            }
        }
        case TOGGLE_PATHING_EDIT_FLIGHT_INFO: {
            if((state.manual_flight?.pathing.length ?? 1)>0) {
                if(state.pathing !== null) {
                    return {
                        ...state,
                        pathing_edit_flight_info: !state.pathing_edit_flight_info,
                        pathing_airline: state.pathing.source,
                        pathing_retrocession_date_number: state.pathing.retrocession_date_number ?? '',
                        pathing_retrocession_date_date: state.pathing.retrocession_date_date? new Date(state.pathing.retrocession_date_date): null,
                        pathing_retrocession_date_type: state.pathing.retrocession_date_date? 'DATE': 'NUMBER',
                        pathing_currency: state.pathing.currency,
                        pathing_pnr_number: state.pathing.pnr_number,
                        pathing_price_adult: state.pathing.price_adult,
                        pathing_purchase_price_adult: state.pathing.purchase_price_adult,
                        pathing_price_child: state.pathing.price_child,
                        pathing_purchase_price_child: state.pathing.purchase_price_child,
                        pathing_price_infant: state.pathing.price_infant,
                        pathing_purchase_price_infant: state.pathing.purchase_price_infant,
                        pathing_taxes_adult: state.pathing.taxes_adult,
                        pathing_taxes_child: state.pathing.taxes_child,
                        pathing_taxes_infant: state.pathing.taxes_infant,
                        pathing_total_stock: state.pathing.total_stock,
                    };

                } else {
                    return {
                        ...state,
                        pathing_edit_flight_info: !state.pathing_edit_flight_info
                    };

                }
            }else {
                return { ...state, pathing_edit_flight_info: !state.pathing_edit_flight_info };
            }
        }
        case TOGGLE_EDIT_OUTBOUND_SEGMENTS: {
            if (state.manual_flight !== null) {
                const { segments_outbound } = getSegments(state.manual_flight);
                return { ...state, segments_outbound: segments_outbound, edit_outbound_segments: !state.edit_outbound_segments };
            } else {
                return { ...state, edit_outbound_segments: !state.edit_outbound_segments };
            }
        }
        case TOGGLE_PATHING_EDIT_OUTBOUND_SEGMENTS: {
            if (state.pathing !== null) {
                const { segments_outbound } = getSegments(state.pathing);
                return { ...state, pathing_segments_outbound: segments_outbound, pathing_edit_outbound_segments: !state.pathing_edit_outbound_segments };
            } else {
                return { ...state, pathing_edit_outbound_segments: !state.pathing_edit_outbound_segments };
            }
        }
        case TOGGLE_EDIT_DOMESTIC_SEGMENTS: {
            if (state.manual_flight !== null) {
                const { segments_domestic } = getSegments(state.manual_flight);
                return { ...state, segments_domestic: segments_domestic, edit_domestic_segments: !state.edit_domestic_segments };
            } else {
                return { ...state, edit_domestic_segments: !state.edit_domestic_segments };
            }
        }
        case TOGGLE_EDIT_RETURN_SEGMENTS: {
            if (state.manual_flight !== null) {
                const { segments_return } = getSegments(state.manual_flight);
                return { ...state, segments_return: segments_return, edit_return_segments: !state.edit_return_segments };
            } else {
                return { ...state, edit_return_segments: !state.edit_return_segments };
            }
        }
        case TOGGLE_PATHING_EDIT_RETURN_SEGMENTS: {
            if (state.pathing !== null) {
                const { segments_return } = getSegments(state.pathing);
                return { ...state, pathing_segments_return: segments_return, pathing_edit_return_segments: !state.pathing_edit_return_segments };
            } else {
                return { ...state, pathing_edit_return_segments: !state.pathing_edit_return_segments };
            }
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_REFRESH: {
            return { ...state,
                refresh: !state.refresh,
                edit_step: 'INFO',
                is_flight_series_open: false,
                pathing: null,
                delete_pathing: null,
                pathings: [],
                refresh_pathings: !state.refresh_pathings,
                loading_pathings: false,
                create: false,
                refresh_edit_flight_series: false,
                from_series:false,
                add_pre_post_pathing: false,
                duplicate: false,
                segments_outbound_first_date: null,
                create_successif: false,
                create_step: 0 };
        }
        case UPDATE_AIRLINE: {
            const segments_outbound: Segment[] = [...state.segments_outbound];
            const segments_domestic: Segment[][] = [...state.segments_domestic];
            const segments_return: Segment[] = [...state.segments_return];
            segments_outbound.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload;
                }
            });
            segments_domestic.map(current_domestic => {
                current_domestic.map(segment => {
                    if (segment.airline === null) {
                        segment.airline = action.payload;
                    }
                });
            });
            segments_return.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload;
                }
            });
            return { ...state, airline: action.payload, airline_error: '', segments_outbound: segments_outbound, segments_domestic: segments_domestic, segments_return: segments_return };
        }
        case UPDATE_AIRLINE_PATHING: {
            const segments_outbound: Segment[] = [...state.pathing_segments_outbound];
            const segments_return: Segment[] = [...state.pathing_segments_return];
            segments_outbound.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload;
                }
            });
            segments_return.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload;
                }
            });
            return { ...state, pathing_airline: action.payload, pathing_airline_error: '', pathing_segments_outbound: segments_outbound,  pathing_segments_return: segments_return };
        }
        case UPDATE_AIRLINE_PATHING_FORMS: {
            const pathing = cloneDeep(state.pathing_forms[action.payload.pathing_index]);
            const segments_outbound: Segment[] = [...pathing.segments_outbound];
            const segments_return: Segment[] = [...pathing.segments_return];
            segments_outbound.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload.value;
                }
            });
            segments_return.map(segment => {
                if (segment.airline === null) {
                    segment.airline = action.payload.value;
                }
            });
            pathing.segments_outbound = segments_outbound;
            pathing.segments_return = segments_return;
            pathing.airline = action.payload.value;
            pathing.airline_error = '';
            return { ...state, pathing_forms: state.pathing_forms.map((pathing_form, index) => index === action.payload.pathing_index? pathing: pathing_form) };
        }
        case UPDATE_CURRENCY: {
            return { ...state, currency: action.payload, currency_error: '' };
        }
        case UPDATE_FILTER_ACTIVE: {
            return { ...state, filter_is_active: action.payload };
        }
        case UPDATE_FILTER_AIRLINE: {
            return { ...state, filter_airline: action.payload };
        }
        case UPDATE_FILTER_AIRPORT: {
            return { ...state, filter_airport: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_END_DATE_GTE: {
            return { ...state, filter_end_date_gte: action.payload };
        }
        case UPDATE_FILTER_END_DATE_LTE: {
            return { ...state, filter_end_date_lte: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_start_date_gte: period !== 'START_DATE' ? null : state.filter_start_date_gte,
                filter_start_date_lte: period !== 'START_DATE' ? null : state.filter_start_date_lte,
                filter_end_date_gte: period !== 'END_DATE' ? null : state.filter_end_date_gte,
                filter_end_date_lte: period !== 'END_DATE' ? null : state.filter_end_date_lte,
                filter_created_date_gte: period !== 'CREATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period !== 'CREATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period !== 'MODIFICATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period !== 'MODIFICATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_FILTER_PNR_NUMBER: {
            return { ...state, filter_pnr_number: action.payload };
        }
        case UPDATE_FILTER_START_DATE_GTE: {
            return { ...state, filter_start_date_gte: action.payload };
        }
        case UPDATE_FILTER_START_DATE_LTE: {
            return { ...state, filter_start_date_lte: action.payload };
        }
        case UPDATE_PNR_NUMBER: {
            return { ...state, pnr_number: action.payload, pnr_number_error: '' };
        }
        case UPDATE_PRICE_ADULT: {
            return { ...state, price_adult: action.payload, price_adult_error: '' };
        }
        case UPDATE_PRICE_CHILD: {
            return { ...state, price_child: action.payload, price_child_error: '' };
        }
        case UPDATE_PRICE_INFANT: {
            return { ...state, price_infant: action.payload, price_infant_error: '' };
        }
        case UPDATE_PURCHASE_PRICE_ADULT: {
            return { ...state, purchase_price_adult: action.payload, purchase_price_adult_error: '' };
        }
        case UPDATE_PURCHASE_PRICE_CHILD: {
            return { ...state, purchase_price_child: action.payload, purchase_price_child_error: '' };
        }
        case UPDATE_PURCHASE_PRICE_INFANT: {
            return { ...state, purchase_price_infant: action.payload, purchase_price_infant_error: '' };
        }
        case UPDATE_PATHING_SEGMENT_PROPERTY: {
            const { key, value, origin, domestic_index, segment_index } = action.payload;
            return updatePathingProperty(value, origin, domestic_index, segment_index, state, key);
        }
        case UPDATE_SEGMENT_AIRCRAFT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'aircraft');
        }
        case UPDATE_SEGMENT_AIRLINE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'airline');
        }
        case UPDATE_SEGMENT_BAG_UNIT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'bag_unit');
        }
        case UPDATE_SEGMENT_CABIN_CLASS: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'cabin_class');
        }
        case UPDATE_SEGMENT_CABIN_CLASS_CODE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'cabin_class_code');
        }
        case UPDATE_SEGMENT_CARRY_BAG_NUMBER: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'carry_bag_number');
        }
        case UPDATE_SEGMENT_CARRY_BAG_WEIGHT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'carry_bag_weight');
        }
        case UPDATE_SEGMENT_CHECKED_BAG_NUMBER: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'checked_bag_number');
        }
        case UPDATE_SEGMENT_CHECKED_BAG_WEIGHT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'checked_bag_weight');
        }
        case UPDATE_SEGMENT_DESTINATION_AIRPORT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'destination_airport');
        }
        case UPDATE_SEGMENT_DESTINATION_STATION: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'destination_station');
        }
        case UPDATE_SEGMENT_DESTINATION_TERMINAL: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'destination_terminal');
        }
        case UPDATE_SEGMENT_DURATION_HOUR: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'duration_hour');
        }
        case UPDATE_SEGMENT_DURATION_MINUTE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'duration_minute');
        }
        case UPDATE_SEGMENT_END_DATE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'date_lte');
        }
        case UPDATE_SEGMENT_END_DATE_HOUR: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'hour_lte');
        }
        case UPDATE_SEGMENT_END_DATE_MINUTE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'minute_lte');
        }
        case UPDATE_SEGMENT_FLIGHT_NUMBER: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'flight_number');
        }
        case UPDATE_SEGMENT_IS_NIGHTLY: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'is_nightly');
        }
        case UPDATE_SEGMENT_MEAL_INCLUDED: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'meal_included');
        }
        case UPDATE_SEGMENT_ORIGIN_AIRPORT: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'origin_airport');
        }
        case UPDATE_SEGMENT_ORIGIN_STATION: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'origin_station');
        }
        case UPDATE_SEGMENT_ORIGIN_TERMINAL: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'origin_terminal');
        }
        case UPDATE_SEGMENT_START_DATE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'date_gte');
        }
        case UPDATE_SEGMENT_START_DATE_HOUR: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'hour_gte');
        }
        case UPDATE_SEGMENT_START_DATE_MINUTE: {
            const { value, origin, domestic_index, segment_index } = action.payload;
            return updateSegmentProperty(value, origin, domestic_index, segment_index, state, 'minute_gte');
        }
        case UPDATE_TAXES_ADULT: {
            return { ...state, taxes_adult: action.payload, taxes_adult_error: '' };
        }
        case UPDATE_TAXES_CHILD: {
            return { ...state, taxes_child: action.payload, taxes_child_error: '' };
        }
        case UPDATE_TAXES_INFANT: {
            return { ...state, taxes_infant: action.payload, taxes_infant_error: '' };
        }
        case UPDATE_TOTAL_STOCK: {
            return { ...state, total_stock: action.payload, total_stock_error: '' };
        }
        case UPDATE_SEGMENT_PERIOD_FIELD : {
            return {
                ...state,
                segments_domestic: action.payload.origin === 'DOMESTIC'? state.segments_domestic.map((domestic, domestic_index) => domestic_index === action.payload.domestic_index
                    ? domestic.map((segment, segment_index) => segment_index === action.payload.segment_index
                        ? { ...segment, periods: segment.periods.map((period, period_index) => period_index === action.payload.period_index
                            ? { ...period, [action.payload.field]: action.payload.value, date_gte_error: action.payload.field === 'date_gte'? '': period.date_gte_error, date_lte_error: action.payload.field === 'date_lte'? '': period.date_lte_error }: period) }: segment  )
                    : domestic): state.segments_domestic,
                segments_outbound: action.payload.origin === 'OUTBOUND'
                    ? state.segments_outbound.map((segment, segment_index) => segment_index === action.payload.segment_index
                        ? { ...segment, periods: segment.periods.map((period, period_index) => period_index === action.payload.period_index
                            ? { ...period, [action.payload.field]: action.payload.value, date_gte_error: action.payload.field === 'date_gte'? '': period.date_gte_error, date_lte_error: action.payload.field === 'date_lte'? '': period.date_lte_error }: period) }: segment  )
                    : state.segments_outbound,
                segments_return: action.payload.origin === 'RETURN'
                    ? state.segments_return.map((segment, segment_index) => segment_index === action.payload.segment_index
                        ? { ...segment, periods: segment.periods.map((period, period_index) => period_index === action.payload.period_index
                            ? { ...period, [action.payload.field]: action.payload.value, date_gte_error: action.payload.field === 'date_gte'? '': period.date_gte_error, date_lte_error: action.payload.field === 'date_lte'? '': period.date_lte_error }: period) }: segment  )
                    : state.segments_return,
            };
        }
        case  UPDATE_FLIGHTS_GENERATIONS_PARAMS: {
            const error = action.payload.field !== 'is_daily'? { [`${action.payload.field}_error`]: '' } : {};
            const flights_generations_params = state.flights_generations_params.map((param, index) => index === action.payload.index?  ({ ...param, ...error, [action.payload.field]: action.payload.value }): param);
            return { ...state, flights_generations_params , retrocession_min_date: getSeriesMinDate(flights_generations_params) };
        }
        case  DELETE_FLIGHTS_GENERATIONS_PARAMS: {
            const flights_generations_params = state.flights_generations_params.filter((param, index) => index !== action.payload.index);
            return { ...state, flights_generations_params: flights_generations_params, retrocession_min_date: getSeriesMinDate(flights_generations_params) };
        }
        case  ADD_FLIGHTS_GENERATIONS_PARAMS: {
            return { ...state, flights_generations_params: [...state.flights_generations_params, { ...EMPTY_FLIGHT_GENERATION_PARAMS, is_one_day: action.payload.is_one_day }] };
        }
        case SET_CREATE_SUCCESSIF: {
            return { ...state, create_successif: action.payload };
        }
        case SET_CREATE_STEP: {
            return { ...state, create_step: action.payload };
        }
        case GENERATE_FLIGHT_SERIES: {
            const { start_date, flight_series } = generateFlightSeries(
                state.flights_generations_params,
                {
                    total_stock: Number(state.total_stock),
                    purchase_price_adult: state.purchase_price_adult,
                    purchase_price_infant: state.purchase_price_infant,
                    purchase_price_child: state.purchase_price_child,
                    price_adult: state.price_adult,
                    price_infant: state.price_infant,
                    price_child: state.price_child,
                    taxes_adult: state.taxes_adult,
                    taxes_infant: state.taxes_infant,
                    taxes_child: state.taxes_child,
                    retrocession_date_date: state.retrocession_date_date,
                    retrocession_date_type: state.retrocession_date_type,
                    circuit_list: state.circuit_list,
                    target: state.target,
                    retrocession_date_number: state.retrocession_date_number
                }
            );
            return { ...state,
                create_step: 1,
                flight_series: flight_series,
                segments_outbound: state.segments_outbound.map((segemnt, index) => index === 0 ? { ...segemnt, date_gte: start_date, min_date_gte: start_date, min_date_lte: start_date }: segment)
            };
        }
        case UPDATE_FLIGHT_SERIES:{
            return { ...state, flight_series: action.payload  };
        }
        case REGROUP_FLIGHT_SERIES: {
            return { ...state, flight_series: regroupManualFlight(action.payload) };
        }
        case UPDATE_RETROCESSION_DATE_DATE: {
            return { ...state, retrocession_date_date: action.payload, retrocession_date_date_error: '' };
        }
        case UPDATE_RETROCESSION_DATE_NUMBER: {
            return { ...state, retrocession_date_number: action.payload };
        }
        case UPDATE_RETROCESSION_DATE_TYPE: {
            return { ...state, retrocession_date_type: action.payload, retrocession_date_number: '', retrocession_date_date: null, retrocession_date_date_error: '' };
        }
        case UPDATE_PATHING_FIELD : {
            return { ...state, [action.payload.field]: action.payload.value, [`${action.payload.field}_error`]: '' };
        }
        case ADD_PRE_POST_PATHING: {
            return {
                ...state,
                add_pre_post_pathing: action.payload,
                pathing_airline: null,
                pathing_airline_error: '',
                pathing_currency: getDefaultCurrency(),
                pathing_currency_error: '',
                pathing_total_stock: 0,
                pathing_total_stock_error: '',
                pathing_pnr_number: '',
                pathing_pnr_number_error: '',
                pathing_price_adult: 0,
                pathing_price_adult_error: '',
                pathing_price_child: 0,
                pathing_price_child_error: '',
                pathing_price_infant: 0,
                pathing_price_infant_error: '',
                pathing_purchase_price_adult: 0,
                pathing_purchase_price_adult_error: '',
                pathing_purchase_price_child: 0,
                pathing_purchase_price_child_error: '',
                pathing_purchase_price_infant: 0,
                pathing_purchase_price_infant_error: '',
                pathing_segments_outbound: [],
                pathing_segments_outbound_control: [],
                pathing_segments_return: [],
                pathing_segments_return_control: [],
                pathing_taxes_adult: 0,
                pathing_taxes_adult_error: '',
                pathing_taxes_child: 0,
                pathing_taxes_child_error: '',
                pathing_taxes_infant: 0,
                pathing_taxes_infant_error: '',
                pathing_segments_outbound_first_date: null
            };
        }
        case SET_FROM_SERIES: {
            return { ...state, from_series: action.payload };
        }
        case SET_EDIT_STEP: {
            return { ...state, edit_step: action.payload };
        }
        case SET_IS_FLIGHT_SERIES_OPEN: {
            return { ...state, is_flight_series_open: action.payload };
        }
        case SET_PATHING: {
            const pathing =  action.payload? getSegments(action.payload) : null;
            return {
                ...state,
                pathing: action.payload,
                pathing_edit_flight_info: false,
                pathing_edit_outbound_segments: false,
                pathing_edit_return_segments: false,
                pathing_airline: action.payload?.source ?? null,
                pathing_currency: action.payload?.currency ?? getDefaultCurrency(),
                pathing_total_stock: action.payload?.total_stock ?? 0,
                pathing_pnr_number: action.payload?.pnr_number ?? '',
                pathing_price_adult: action.payload?.price_adult ? parseFloat(action.payload.price_adult as string) : 0,
                pathing_price_child: action.payload?.price_child ? parseFloat(action.payload.price_child as string) : 0,
                pathing_price_infant: action.payload?.price_infant ? parseFloat(action.payload.price_infant as string) : 0,
                pathing_purchase_price_adult: action.payload?.purchase_price_adult ? parseFloat(action.payload.purchase_price_adult as string) : 0,
                pathing_purchase_price_child: action.payload?.purchase_price_child ? parseFloat(action.payload.purchase_price_child as string) : 0,
                pathing_purchase_price_infant: action.payload?.purchase_price_infant ? parseFloat(action.payload.purchase_price_infant as string) : 0,
                pathing_taxes_adult: action.payload?.taxes_adult ? parseFloat(action.payload.taxes_adult as string) : 0,
                pathing_taxes_child: action.payload?.taxes_child ? parseFloat(action.payload.taxes_child as string) : 0,
                pathing_taxes_infant: action.payload?.taxes_infant ? parseFloat(action.payload.taxes_infant as string) : 0,
                pathing_segments_outbound: pathing?.segments_outbound ?? [],
                pathing_segments_outbound_control: pathing?.segments_outbound ?? [],
                pathing_segments_return: pathing?.segments_return ?? [],
                pathing_segments_return_control: pathing?.segments_return ?? [],
            };
        }
        case SET_PATHINGS: {
            if(state.pathing) {
                return { ...state, pathings: action.payload, pathing: action.payload.find(flight => flight.id === state.pathing?.id) ?? null };
            } else {
                return { ...state, pathings: action.payload };
            }
        }
        case SET_REFRESH_PATHINGS: {
            return {
                ...state,
                refresh_pathings: !state.refresh_pathings,
                pathing_segments_outbound_first_date: null,
                pathing_edit_flight_info: false,
                pathing_edit_outbound_segments: false,
                pathing_edit_return_segments: false,
                delete_pathing: null,
            };
        }
        case SET_LOADING_PATHINGS: {
            return { ...state, loading_pathings: action.payload };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case ADD_PATHING_FORM: {
            return { ...state, pathing_forms: [...state.pathing_forms, EMPTY_PATHING_FORM] };
        }
        case DELETE_PATHING_FORM: {
            return { ...state, pathing_forms: state.pathing_forms.filter((_, index) => index !== action.payload) };
        }
        case UPDATE_PATHING_FORM: {
            return { ...state, pathing_forms: state.pathing_forms.map((pathing, index) => index === action.payload.pathing_form_index ? ({ ...pathing, [action.payload.key]: action.payload.value, [`${action.payload.key}_error`]: '' }): pathing) };
        }
        case UPDATE_PATHING_FORMS_SEGMENT_PROPERTY: {
            const { pathing_index, key, value, origin, segment_index } = action.payload;
            return updatePathingFormsSegmentProperty(pathing_index, value, origin, segment_index, state, key);
        }
        case UPDATE_CIRCUIT_LIST: {
            return { ...state, circuit_list: action.payload };
        }
        case UPDATE_TARGET: {
            return { ...state, target: action.payload };
        }
        case SET_SELECTED_MANUAL_FLIGHTS: {
            return { ...state, selected_manual_flights: action.payload };
        }
        case SET_MANUAL_FLIGHT_BATCH_ACTIVATE: {
            return { ...state, manual_flight_batch_activate: action.payload };
        }
        case SET_MANUAL_FLIGHT_BATCH_DELETE: {
            return { ...state, manual_flight_batch_delete: action.payload };
        }
        default:
            return state;
    }
};